import React from "react";
import { useTranslation } from "react-i18next";
import StarRating from "../components/StarRating";

const Reservation: React.FC = () => {
  const { t: tContact } = useTranslation("contact");
  const { t: tHome } = useTranslation("home");

  return (
    <div className="reservations">
      <div className="icon">
        <span className="flaticon-call"></span>
      </div>
      <div className="text">
        <p>{tHome("about.reservation")}</p>{" "}
        <a href={`tel:${tContact("phone.number")}`}>
          {tContact("phone.label")}
        </a>
      </div>
    </div>
  );
};

const AboutSection: React.FC = () => {
  const { t: tHome } = useTranslation("home");

  return (
    <section className="about section-padding">
      <div className="container">
        <div className="row">
          <div className="mb-30 animate-box" data-animate-effect="fadeInUp">
            <StarRating rating={3} />
            <div className="section-subtitle">{tHome("about.title")}</div>
            <div className="section-title">{tHome("about.description")}</div>
            <p>{tHome("about.p1")}</p>
            <p>{tHome("about.p2")}</p>
            <p>{tHome("about.p3")}</p>
            <Reservation />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
